import { create } from 'zustand';

const useConfirmStore = create((set) => ({
  isOpen: false,
  title: '',
  message: '',
  onConfirm: () => {},
  type: 'danger',
  confirmText: 'Confirmar',
  cancelText: 'Cancelar',
  
  openConfirm: ({ title, message, onConfirm, type = 'danger', confirmText = 'Confirmar', cancelText = 'Cancelar' }) => {
    set({
      isOpen: true,
      title,
      message,
      onConfirm,
      type,
      confirmText,
      cancelText
    });
  },
  
  closeConfirm: () => {
    set({ isOpen: false });
  }
}));

export const useConfirm = () => {
  const openConfirm = useConfirmStore(state => state.openConfirm);
  
  return (options) => {
    return new Promise((resolve) => {
      openConfirm({
        ...options,
        onConfirm: () => {
          resolve(true);
          if (options.onConfirm) options.onConfirm();
        }
      });
    });
  };
};

export default useConfirmStore;
